import { render, staticRenderFns } from "./KioskQR.vue?vue&type=template&id=df8b3356"
import script from "./KioskQR.vue?vue&type=script&lang=js"
export * from "./KioskQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports